import MUIDialog from '@material-ui/core/Dialog';
import styled from 'styled-components';

export const Dialog = styled(MUIDialog)`
  & .MuiPaper-root {
    max-width: ${({ maxWidth }) => maxWidth ?? '95vw'};
    max-height: 95vh;
    border-radius: 18px;
    overflow: hidden;
  }
`;
